import React, { useEffect, useState } from 'react';
import FullScreenLoader from './loader/Loader';
import { useAttendeeStore,useAdminStore,useOrganizerStore,useScannerStore } from '../utils/store';


export default function AuthGate({ children }) {
  const [booted, setBooted] = useState(false);

  const attendee = useAttendeeStore();
  const admin = useAdminStore();
  const organizer = useOrganizerStore();
  const scanner = useScannerStore();

  useEffect(() => {
    const hydrateAll = async () => {
      await Promise.all([
        attendee.verifySession(),
        admin.verifySession(),
        organizer.verifySession(),
        scanner.verifySession(),
      ]);
      setBooted(true);
    };

    hydrateAll();
  }, []);

  const isHydrating =
    attendee.isHydrating ||
    admin.isHydrating ||
    organizer.isHydrating ||
    scanner.isHydrating;

  if (!booted || isHydrating) return <FullScreenLoader />;

  return children;
}
